/**
 * Kriteret e rekrutimit te ndërfaqja — pasqyrë e fjalorit të serverit.
 *
 * Vlerësimi bëhet te serveri dhe kthehet rresht për rresht me arsyen e vet;
 * këtu mbahen vetëm etiketat, që formulari të mos shpikë kode dhe rezultati të
 * lexohet shqip. Burimi: `backend/services/recruitmentCriteria.js`.
 */

export const LANGUAGE_LEVELS = ['A1', 'A2', 'B1', 'B2', 'C1', 'C2'];

export const LANGUAGES = [
  { code: 'sq', label: 'Shqip' }, { code: 'en', label: 'Anglisht' },
  { code: 'de', label: 'Gjermanisht' }, { code: 'it', label: 'Italisht' },
  { code: 'fr', label: 'Frëngjisht' }, { code: 'tr', label: 'Turqisht' },
  { code: 'sr', label: 'Serbisht' }, { code: 'nl', label: 'Holandisht' },
];

export const EMPLOYMENT_TYPES = [
  { code: 'full_time', label: 'Me orar të plotë' },
  { code: 'part_time', label: 'Me orar të pjesshëm' },
  { code: 'contract', label: 'Me kontratë' },
  { code: 'seasonal', label: 'Sezonal' },
  { code: 'internship', label: 'Praktikë' },
];

export const WORKPLACE_TYPES = [
  { code: 'onsite', label: 'Në zyrë' },
  { code: 'hybrid', label: 'Hibrid' },
  { code: 'remote', label: 'Në distancë' },
];

const pick = (list, code) => list.find((x) => x.code === code) || null;
export const languageLabel = (c) => pick(LANGUAGES, c)?.label || c || '—';
export const employmentLabel = (c) => pick(EMPLOYMENT_TYPES, c)?.label || c || '—';
export const workplaceLabel = (c) => pick(WORKPLACE_TYPES, c)?.label || c || '—';

/**
 * Etiketa e verdiktit. «E panjohur» nuk është «jo».
 *
 * Mungesa e të dhënës te një aplikim i vitit 2025 nuk provon asgjë për personin;
 * ngjyrosja e saj si dështim do ta hiqte nga lista dikë që mund të ishte i duhuri.
 */
export const VERDICT = {
  match:   { label: 'përputhet',  color: 'success', mark: '✓' },
  miss:    { label: 'nuk përputhet', color: 'error', mark: '✕' },
  unknown: { label: 'nuk dihet',  color: 'default', mark: '?' },
};

export const verdictMeta = (v) => VERDICT[v] || VERDICT.unknown;

/** Përmbledhje në fjalë: «3/5 kritere përputhen», jo një përqindje pa arsye. */
export function matchSummaryText(s = {}) {
  if (!s.total) return 'Pa kritere të përcaktuara';
  const parts = [`${s.matched}/${s.total} kritere përputhen`];
  if (s.unknown) parts.push(`${s.unknown} nuk dihen`);
  if (s.requiredMissed) parts.push(`${s.requiredMissed} të detyrueshme mungojnë`);
  return parts.join(' · ');
}
